import { isEmpty } from "lodash";

import ExpandableLinks from "../../../../../../components/ExpandableItems/ExpandableLinks/ExpandableLinks";
import MultiSelectWithAdditionField from "../../../../../../components/forms/MultiSelectWithAdditionField";

import { type NormalizedDropdown } from "utils/miscellaneousUtils";
import { ValidatedForm } from "../../../../../../components/forms";
import { type SettingsFormProps } from "../types";
import { ReadOnlyEmptyStates } from "enums";

import styles from "./settingsForm.module.scss";
import { faCodeBranch } from "@fortawesome/pro-solid-svg-icons";

const SettingsForm = (props: SettingsFormProps) => {
  const { videoInfo, isLoading, tagsFormik, entityId } = props;

  const handleChangeTag = async (
    field: "labels" | "softwareApplications",
    value: NormalizedDropdown,
    shouldValidate?: boolean,
  ) => {
    const errors = await (tagsFormik.setFieldValue(field, value.selected, shouldValidate) as unknown as Promise<void>);
    if (isEmpty(errors?.[field])) {
      props.updateTags(entityId, value.selected, field);
    }
  };

  const renderFields = () => {
    const { normalizedTags, isDisabled } = props;
    const isReadOnlyView = isDisabled;

    return (
      <div className={styles.root}>
        <div className={styles["settings-fields"]}>
          <MultiSelectWithAdditionField
            {...tagsFormik}
            options={normalizedTags?.softwareApplications}
            label="Software Application"
            value={tagsFormik.values.softwareApplications}
            propertyName="softwareApplications"
            disabled={isDisabled}
            shouldValidate
            isCaseSensitive
            isReadOnlyView={isReadOnlyView}
            readOnlyEmptyState={ReadOnlyEmptyStates.NoSoftwareApplicationsSelected}
            setFieldValue={handleChangeTag}
          />
          <MultiSelectWithAdditionField
            {...tagsFormik}
            options={normalizedTags?.labels}
            label="Labels"
            value={tagsFormik.values.labels}
            propertyName="labels"
            disabled={isDisabled}
            shouldValidate
            isCaseSensitive
            isReadOnlyView={isReadOnlyView}
            readOnlyEmptyState={ReadOnlyEmptyStates.NoLabelsSelected}
            setFieldValue={handleChangeTag}
          />
          <ExpandableLinks
            label="Associated Flows"
            linkFormatter={(id) => `/content/flows/${id}/items`}
            iconName="fa-code-branch"
            icon={faCodeBranch}
            links={videoInfo.flows}
            isReadOnlyView={isReadOnlyView}
            readOnlyEmptyState={ReadOnlyEmptyStates.NoAssociatedFlows}
          />
        </div>
      </div>
    );
  };

  return (
    <ValidatedForm withoutFormik isLoading={isLoading} formWidthComputer={6} disablePreventTransitionPrompt>
      {renderFields}
    </ValidatedForm>
  );
};

export default SettingsForm;
